import { type CartIntermediateEntryObject } from './CartIntermediateContextValue'

export const cartIntermediateAccessorGetProductFamilyIds = ({
  product,
}: {
  product: CartIntermediateEntryObject['product'] | undefined
}): string[] | undefined => {
  if (!product || !('variants' in product)) {
    return undefined
  }

  return product.variants.map(({ upid }) => upid)
}
